export function supportBigInt() {
  return typeof BigInt === 'function';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-input-number/es/utils/supportUtil.js
// module id = 471
// module chunks = 0